module.exports = __webpack_public_path__ + "media/images/bag-56f37f59c281fb3e98644f7cb1612162.png";